import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '~/stores/auth-store'

export interface AuthGuardProps {
    children: ReactNode
}

/**
 * 인증 가드(세션 쿠키 기반). 세션 확인 전(`unknown`)에는 깜빡임 방지를 위해 아무것도
 * 렌더하지 않고, 미인증이면 /login으로 보내며 원래 경로를 state로 넘긴다.
 */
export function AuthGuard({ children }: AuthGuardProps) {
    const status = useAuthStore((s) => s.status)
    const location = useLocation()

    if (status === 'unknown') return null

    if (status === 'unauthenticated') {
        return (
            <Navigate
                to='/login'
                replace
                state={{ from: location.pathname + location.search }}
            />
        )
    }

    return <>{children}</>
}
